var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "48e73b79fe4d18ee0bbd93b7372bcfde.png",
    width: 375,
    height: 40
});